import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  Flex,
} from '@chakra-ui/react';
import { IKanbanColumn } from '../../hooks/useKanban';

interface KanbanColumnModalProps {
  isOpen: boolean;
  onClose: () => void;
  column: IKanbanColumn | null;
  // eslint-disable-next-line no-unused-vars
  onSave: (titulo: string, projetoId?: number, columnId?: number) => void;
}

export const KanbanColumnModal: React.FC<KanbanColumnModalProps> = ({
  isOpen,
  onClose,
  column,
  onSave,
}) => {
  const [titulo, setTitulo] = useState('');

  useEffect(() => {
    if (column) {
      setTitulo(column.titulo);
    } else {
      setTitulo('');
    }
  }, [column, isOpen]);

  const handleSave = () => {
    if (titulo.trim()) {
      onSave(titulo.trim(), column?.projeto_id || undefined, column?.id);
      onClose();
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && titulo.trim()) {
      handleSave();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(4px)" />
      <ModalContent borderRadius="xl">
        <ModalHeader fontSize="lg" fontWeight="600">
          {column ? 'Editar Coluna' : 'Nova Coluna'}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <FormControl>
            <FormLabel fontSize="sm" fontWeight="500" color="gray.700">
              Titulo
            </FormLabel>
            <Input
              value={titulo}
              onChange={e => setTitulo(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder="Ex: A Fazer, Em Progresso, Concluido..."
              borderRadius="lg"
              _focus={{
                borderColor: 'blue.400',
                boxShadow: '0 0 0 1px var(--chakra-colors-blue-400)',
              }}
              autoFocus
            />
          </FormControl>
        </ModalBody>

        <ModalFooter borderTop="1px solid" borderColor="gray.100" pt={4}>
          <Flex gap={2}>
            <Button variant="ghost" onClick={onClose} borderRadius="lg" fontWeight="500">
              Cancelar
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleSave}
              isDisabled={!titulo.trim()}
              borderRadius="lg"
              fontWeight="500"
            >
              {column ? 'Salvar' : 'Criar'}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
